import { render, staticRenderFns } from "./tenant__list.vue?vue&type=template&id=3a24de6f"
import script from "./tenant__list.vue?vue&type=script&lang=js"
export * from "./tenant__list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports